import { mutator } from 'satcheljs';
import Folder from '../store/schema/Folder';
import { setMailboxData } from '../actions/internalActions';
import MailboxLoadStateEnum from '../store/schema/MailboxLoadStateEnum';
import MailBoxData from '../store/schema/MailboxData';
import getMailboxTable from '../selectors/getMailboxTable';

/**
 * Mutator that sets the mailbox data.
 * @param actionMessage
 */
export default mutator(setMailboxData, actionMessage => {
    const mailbox: MailBoxData = {
        id: actionMessage.mailboxId,
        rootFolder: actionMessage.folderValue as Folder,
        loadingState: actionMessage.loadingState as MailboxLoadStateEnum,
    };
    getMailboxTable().set(actionMessage.mailboxId, mailbox);
});
